const useCases = {
  0: 'Case study 1: Correlation between intellectual disability and paediatric rare diseases',
  1: 'Case study 2: AI use for diagnosis of retinal dystrophies',
  2: 'Case study 3: Prediction of self harm and suicide in Autism patients',
};

export const mapUseCases = (input: number[]): string[] => {
  const result: string[] = [];

  for (const useCase of input) {
    if (useCase >= 0 && useCase <= 2) {
      result.push(useCases[useCase]);
    }
  }

  return result;
};
